var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBAtm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "2 1 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    clipPath: "url(#clip0_4433_72645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.6262 5.85508L2.39345 10H1.40039L3.08454 5H3.71648L3.6262 5.85508ZM4.65039 10L3.41452 5.85508L3.3149 5H3.95307L5.64656 10H4.65039ZM4.59436 8.13874V8.94574H2.20044V8.13874H4.59436Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.70738 5V10H6.77659V5H7.70738ZM9.10202 5V5.80701H5.40374V5H9.10202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0608 5H10.6515L12.0158 8.67102L13.1801 5H13.9708L12.3333 10H11.6983L10.0608 5ZM9.63435 5H10.4219L10.5651 8.5783V10H9.63435V5ZM13.6097 5H14.4004V10H13.4665V8.5783L13.6097 5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.6262 5.85508L2.39345 10H1.40039L3.08454 5H3.71648L3.6262 5.85508ZM4.65039 10L3.41452 5.85508L3.3149 5H3.95307L5.64656 10H4.65039ZM4.59436 8.13874V8.94574H2.20044V8.13874H4.59436Z",
    stroke: "white",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.70738 5V10H6.77659V5H7.70738ZM9.10202 5V5.80701H5.40374V5H9.10202Z",
    stroke: "white",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0608 5H10.6515L12.0158 8.67102L13.1801 5H13.9708L12.3333 10H11.6983L10.0608 5ZM9.63435 5H10.4219L10.5651 8.5783V10H9.63435V5ZM13.6097 5H14.4004V10H13.4665V8.5783L13.6097 5Z",
    stroke: "white",
    strokeWidth: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4433_72645"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.400391 0.0799561)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBAtm);
export default __webpack_public_path__ + "static/media/b-atm.8e26c9ef94c4dfc19f0f5bc58ad8b078.svg";
export { ForwardRef as ReactComponent };